import { WindowLocationWrapper } from "../window_wrapping/WindowLocationWrapper";
import { TrackingPermissionChecker } from "./TrackingPermissionChecker";

export class ThirdPartyTrackingPermissionChecker
	implements TrackingPermissionChecker
{
	constructor(
		private readonly windowLocation: WindowLocationWrapper,
		private readonly internalTrackingPermissionChecker: TrackingPermissionChecker
	) {
		// do nothing
	}

	/**
	 * Determines whether tracking data we send to third parties should be enabled.
	 *
	 * tracking.js name is 'trackingEnabled'.
	 *
	 * @returns True or false.
	 */
	isTrackingEnabled(): boolean {
		return (
			!this.doesPersonallyIdentifiableInformationExistOnPage() &&
			this.internalTrackingPermissionChecker.isTrackingEnabled()
		);
	}

	/**
	 * Determines whether Personally Identifiable Information(PII) exists in query string.
	 * Used by isTrackingEnabled() as we don't want to enable tracking as the third party resources that get loaded
	 * can read the referrer and harvest that data.
	 *
	 * tracking.js name is 'piiExistsInQueryString'.
	 *
	 * @returns True or false.
	 */
	private doesPersonallyIdentifiableInformationExistOnPage(): boolean {
		const queryString = this.windowLocation.search;
		return (
			queryString.includes("@") ||
			queryString.includes("%40") /*encoded @*/ ||
			queryString.includes("%2540") /*double encoded @*/ ||
			/*some of the filtering the ticket center(employee view) uses could include PII so just don't do any tracking on that page*/
			(this.windowLocation.pathname.includes("/tickets/") &&
				queryString.includes("filter="))
		);
	}
}
